import { render } from "./CoreHeader.vue?vue&type=template&id=31d68490&scoped=true"
import script from "./CoreHeader.vue?vue&type=script&lang=js"
export * from "./CoreHeader.vue?vue&type=script&lang=js"

import "./CoreHeader.vue?vue&type=style&index=0&id=31d68490&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d68490"]])

export default __exports__